import React, { useEffect } from "react"
import types from "prop-types"
import { isEqual } from "lodash-es";
import { useSelector } from "react-redux";
import { groups } from "reduxSlices/groupsSlice"
import { useTaskFormContext } from "contexts/TaskFormContext"
/* eslint-disable max-len */
import TaskGroupSelector from "views/FormSubmission/FormSubmissionTabs/ActivitiesContent/TaskForms/TaskFields/UI/TaskGroupSelector"
/* eslint-enable max-len */

const TaskMemberGroupSelector = ({ className = "" }) => {
  const allGroups = useSelector(groups, isEqual)

  const { addMemberGroupId, taskAssigneeGroupIds, taskMemberGroupIds } = useTaskFormContext()

  const selectableGroups = allGroups.reduce((groupList, group) => {
    if (!taskMemberGroupIds.includes(group.id)) {
      groupList.push(
        {
          ...group,
          ...(taskAssigneeGroupIds.includes(group.id) && { marker: "Assignee" }),
        },
      )
    }
    return groupList
  }, [])

  useEffect(() => {
    window.dispatchEvent(new window.Event("resize"))
  }, [taskMemberGroupIds.length])

  return (
    <TaskGroupSelector
      className={className}
      groups={selectableGroups}
      onChange={addMemberGroupId}
    />
  )
}

TaskMemberGroupSelector.propTypes = {
  className: types.string,
}

export default TaskMemberGroupSelector
